import React, { useEffect, useState } from 'react';
import { handleGetRequest } from '../../service/GetTemplate';

export default function MachineCatalogFields({ routeId, locationId, onChange, disabled }) {
    const [routes, setRoutes] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => {
        let alive = true;
        Promise.resolve(handleGetRequest('machine/catalog/routes', false)).then(response => {
            if (!alive) return;
            if (Array.isArray(response?.data)) setRoutes(response.data);
            else setError('No se pudo cargar el catálogo de rutas. Vuelve a abrir el formulario.');
        }).catch(() => { if (alive) setError('No se pudo cargar el catálogo de rutas.'); });
        return () => { alive = false; };
    }, []);
    useEffect(() => {
        let alive = true;
        setLocations([]);
        if (!routeId) { setLoading(false); return () => { alive = false; }; }
        setLoading(true);
        Promise.resolve(handleGetRequest(`machine/catalog/routes/${routeId}/locations`, false)).then(response => {
            if (!alive) return;
            if (Array.isArray(response?.data)) setLocations(response.data);
            else setError('No se pudieron cargar las ubicaciones. Vuelve a abrir el formulario.');
        }).catch(() => { if (alive) setError('No se pudieron cargar las ubicaciones.'); })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [routeId]);
    const choices = (items, selected) => items.filter(item => item.isActive || item._id === selected);
    return <div className="col-12">
        <div className="grid">
            <div className="col-12 md:col-6 field">
                <label htmlFor="master-route">Ruta del catálogo</label>
                <select id="master-route" className="p-inputtext w-full" value={routeId || ''} disabled={disabled || !!error}
                    onChange={event => onChange(event.target.value, '')}>
                    <option value="">Sin vínculo al catálogo</option>
                    {choices(routes, routeId).map(item => <option key={item._id} value={item._id} disabled={!item.isActive}>{item.name}{!item.isActive ? ' (inactiva)' : ''}</option>)}
                </select>
            </div>
            <div className="col-12 md:col-6 field">
                <label htmlFor="master-location">Ubicación del catálogo</label>
                <select id="master-location" className="p-inputtext w-full" value={locationId || ''} disabled={disabled || !routeId || loading || !!error}
                    onChange={event => onChange(routeId, event.target.value)}>
                    <option value="">{loading ? 'Cargando ubicaciones…' : 'Selecciona una ubicación'}</option>
                    {choices(locations, locationId).map(item => <option key={item._id} value={item._id} disabled={!item.isActive}>{item.name}{!item.isActive ? ' (inactiva)' : ''}</option>)}
                </select>
            </div>
        </div>
        {error && <p role="alert" className="p-error">{error}</p>}
        {routeId && !locationId && <p className="p-error">Selecciona una ubicación para completar el vínculo.</p>}
    </div>;
}
